;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "croma7ozk7c"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="croma7ozk7c"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/sY0Wi3fvkunCjral/call_to_action/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "zygvq1sla1"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="zygvq1sla1"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RGVjLS0yMDIw/NjA3NjY5NzM1/release-12-2020/pages/iB9GgPC4nbA3NxEy/section2/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "x52gwp93dda"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="x52gwp93dda"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/Sh7B9Vqrnv0tEDle/bannder_bottom/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "tcw22bxzze9"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      _dom  = _this.find('.lh-counter-section'),
      counter = _this.find('.lh-counter-number');
  function numberWithCommas(num , separator) {
    if(!separator) return num;
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }
  let regexExt    = /([^\d]+)$/g;
  let regexFText  = /^([^\d]+)/g;
  function getTextInNumber(num, regex){
    f = regex.exec(num.toString());
    return f ? f[0] : ''
  }
  function getSeparatorNumber(num){
    num = num.toString().replace(regexExt,'').replace(regexFText,'');
    separator = /([^\d]+)/g.exec(num.toString());
    return separator ? separator[0] : '';
  }
  function getNum(num){
    num = num.toString().replace(/([^\d])/g,'');
    num = parseInt(num);
    return num ? num : 0;
  }
  function startCounter(){
    _dom.addClass('lh-init');
    counter.each(function() {
    var $this     = $(this),
        num       = $this.attr('data-number'),
        countTo   = getNum(num),
        ext       = getTextInNumber(num, regexExt),
        fText     = getTextInNumber(num, regexFText),
        separator = getSeparatorNumber(num);
    if(countTo < 1) return;
    $({ countNum: 0}).animate({
      countNum: countTo
      },
      {
        duration: parseFloat(section.settings.duration) * 1000,
        easing:'linear',
        step: function() {
          $this.text(fText + numberWithCommas(Math.floor(this.countNum), separator));
        },
        complete: function() {
          $this.text(fText + numberWithCommas(Math.floor(this.countNum), separator) + ext);
        }

      });
    });
  }
  function isAnyPartOfElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
  }
  var time ;
  $(window).on('scroll resize',function(){
    if(time) clearTimeout(time);
    time = setTimeout(function(){
      if(!_dom.hasClass('lh-init')){
         isAnyPartOfElementInViewport(counter[0]) && startCounter();
      }
    },150);

  }).trigger('scroll');
 };						cb.bind($('section[data-section-id="tcw22bxzze9"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="tcw22bxzze9"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/gx9CeGoZjAM2isuB/counter/",						settings: {"duration":1}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "ya45x2xmizb"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="ya45x2xmizb"]').get(0))({						url: "https://library.layouthub.com/HUB/files/SmFuLS0yMDIx/NjEwNDM1MTg1/release-1-2021/pages/tRqiempHv4yxnf1O/form/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "xbkhaxuaav"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="xbkhaxuaav"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/fsSGjy8tnJ6bHlzF/Description/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "0p9mb7sibup"							}), success: c, error: e});						}, cb  = function(section, $) {window.HUB = window.HUB || {};

window.HUB.formatMoney = window.HUB.formatMoney ||  function(t, r) {
    function n(t, r) {
        return void 0 === t ? r : t
    }
    function e(t, r, e, o) {
        if (r = n(r, 2),
        e = n(e, ","),
        o = n(o, "."),
        isNaN(t) || null == t)
            return 0;
        var a = (t = (t / 100).toFixed(r)).split(".");
        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e) + (a[1] ? o + a[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = ""
      , a = /\{\{\s*(\w+)\s*\}\}/
      , i = r || '${{amount}}';
    switch (i.match(a)[1]) {
    case "amount":
        o = e(t, 2);
        break;
    case "amount_no_decimals":
        o = e(t, 0);
        break;
    case "amount_with_comma_separator":
        o = e(t, 2, ".", ",");
        break;
    case "amount_with_space_separator":
        o = e(t, 2, " ", ",");
        break;
    case "amount_with_period_and_space_separator":
        o = e(t, 2, " ", ".");
        break;
    case "amount_no_decimals_with_comma_separator":
        o = e(t, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        o = e(t, 0, ".", "");
        break;
    case "amount_with_space_separator":
        o = e(t, 2, ",", "");
        break;
    case "amount_with_apostrophe_separator":
        o = e(t, 2, "'", ".")
    }
    return i.replace(a, o)
};;var cb  = function($) {
	var $this = jQuery(this);
	$this.find('.lh-tab-title .lh-item-title').click(function(){
			var target = $(this).data('target');
			if(!$(this).hasClass('active')){
				$(this).addClass('active');
				$(this).siblings('.active').removeClass('active');
				$this.find('.lh-item-collection.' +target).addClass('active');
				$this.find('.lh-item-collection.' +target).siblings('.active').removeClass('active');
			}
	});
	initRating();
	function initRating(){
			if(!document.querySelector('#lh-fake-review') && !window.SPR && window.LAYOUTHUB_LIVE === true)
	    {

				jQuery.get('https://productreviews.shopifycdn.com/assets/v4/spr.js', function(code) {
					var regex = new RegExp(['"','/','/'].join(''),'gm');
					code = code.replace(regex, '"https://').replace(/SPR\./g,'window.SPR.').replace('window.SPR=','window.SPR=window.SPR || ');
					code = code.replace('return r=t.remote_id.toString()','if(!t.remote_id)return 0;return r=t.remote_id.toString()');
					code = code.replace('return r.fn.serializeObject','return !r || !r.fb ? false : r.fn.serializeObject');
					var blob = new Blob([code], {
						type: "application/javascript"
					});
					var url = URL.createObjectURL(blob);
					var script = document.createElement("script");
					script.src = url;
					script.id = "lh-fake-review";
					script.type = "text/javascript";
					if (!window.SPR){
						document.head.append(script);
					}

				})
	    }
	    else
	    {
	      if(window.SPR && window.SPR.$){
					if(true){
						window.SPR.loadjQueryExtentions(window.SPR.$);
						window.SPR.$(document).ready(function() {
								return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
						})
					}
	      }
	    }
	}
 };						cb.bind($('section[data-section-id="0p9mb7sibup"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="0p9mb7sibup"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RGVjLS0yMDIw/NjA3NjY5NzM1/release-12-2020/pages/o2rPbwRsZxlMD9vW/o-product/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});